module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Modern Maro Glajurat1.ec76c05a.jpg";